export default __webpack_public_path__ + "static/media/SourceSerifPro-BoldItalic.9f9b1eb2.ttf";